import React, { useRef, useCallback } from "react";
import { FormSpy } from "react-final-form";

type DirtyFormSpyProps = {
  onDirty?: () => void;
  onClean?: () => void;
};

const DirtyFormSpy = ({ onDirty, onClean }: DirtyFormSpyProps) => {
  const firstRender = useRef(true);

  const onChange = useCallback(
    ({ dirty }: { dirty: boolean }) => {
      if (firstRender.current) {
        firstRender.current = false;
      } else {
        if (dirty && onDirty) onDirty();
        else onClean && onClean();
      }
    },
    [onClean, onDirty]
  );

  return <FormSpy subscription={{ dirty: true }} onChange={onChange} />;
};

export default DirtyFormSpy;
